import React, { useRef } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { storage } from '@/utils/utils';
import { DASHBOARD_GUIDE_HIDE } from '../GuideModule/GuideDashboardBox';

import './index.scss';

export default function UserGuideBox(props: any) {
  const {
    data,
    setShowGuide,
    className,
    guideHideKey = DASHBOARD_GUIDE_HIDE,
    loading,
  } = props;
  const ref = useRef<HTMLDivElement>(null);
  return (
    <>
      <div
        ref={ref}
        className={`db-guidebox animation--show${` ` + className}`}
      >
        <div className="db-guidebox-hd">
          <div className="db-guidebox-title">{data.mainTitle}</div>
          <div className="db-guidebox-des">{data.mainDes}</div>
        </div>
        <div className="db-guidebox-bd">
          <div className="db-guidebox-tit">{data.blockTitle}</div>

          <div className="db-guidebox-taskbox">
            {(loading ? [] : data.blockList).map((item: any, index: any) => (
              <div
                key={index}
                className={`db-guidebox-taskitem${
                  item.checked ? ' checked' : ''
                }`}
                onClick={() => {
                  item.onClick && item.onClick();
                }}
              >
                <div className="db-guidebox-taskitem-info">
                  <div className="db-guidebox-taskitem-tit">{item.tit}</div>
                  <div className="db-guidebox-taskitem-des">{item.des}</div>
                </div>
                <div className="db-guidebox-taskitem-righticon">
                  {item.checked ? (
                    <div className="db-guidebox-taskitem-checked">
                      <SvgIcon type="right-good" />
                    </div>
                  ) : (
                    <div className="db-guidebox-taskitem-more">
                      <SvgIcon type="arrow-right" />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div
          className="db-guidebox-close"
          onClick={() => {
            if (ref.current) {
              ref.current.classList.remove('animation--show');
              ref.current.classList.add('animation--hide');
            }
            setTimeout(() => {
              setShowGuide(false);
              storage.setItem(guideHideKey, true);
              const $ele = document.querySelector('.dbh-nav-help');
              if ($ele) {
                $ele.classList.add('db-help-highlight');
                setTimeout(() => {
                  $ele.classList.remove('db-help-highlight');
                }, 300);
              }
            }, 300);
          }}
        >
          <SvgIcon type="clonse" />
        </div>
      </div>
    </>
  );
}
